import Api from "./Api";
import Csrf from "./Csrf";

export default {

  async get(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/marketing/email");
  },

  async getEmails(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/marketing/email/list");
  },


  async update(locationid, data) {
    await Csrf.getCookie();

    return Api.post("/locations/" + locationid + "/marketing/email", data);
  }
};